// extracted by mini-css-extract-plugin
export default {"title":"HeaderTitle_title__nDG0C"};